import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Cacheable } from "ts-cacheable";

import { environment } from "@environments/environment";

import { ParamsService } from "@shared/Services/params.service";

import { CertificateCoverage } from "@RGVSI/ClientsAndPolicies/Certificates/Types/Interfaces/base-certificate.interface";
import { DetailedPolicy, Policy } from "@RGVSI/Shared/Types/Interfaces/policy.interface";

import { AssociatedPolicy } from "../Types/associated-policy.interface";
import { PolicyCoveragesFilter } from "../Types/policy-coverages-filter.interface";

const { enlineaBackendUrl } = environment;

@Injectable({
  providedIn: "root",
})
export class MyPoliciesRepository {
  constructor(private paramsService: ParamsService, private http: HttpClient) {}

  @Cacheable()
  public getMyPolicies(
    {
      identification,
      identificationTypeCode,
    }: {
      identificationTypeCode: string;
      identification: string;
    },
    spinner: boolean = true
  ): Observable<Policy[]> {
    const params = this.paramsService.mapRequestParams({
      identification,
      identificationTypeCode,
    });
    return this.http.get<Policy[]>(`${enlineaBackendUrl}/api/seguros/Policies?spinner=${spinner}`, { params });
  }

  @Cacheable()
  public getPolicyDetail(policyIdentification: string): Observable<DetailedPolicy> {
    return this.http.get<DetailedPolicy>(`${enlineaBackendUrl}/api/seguros/Policies/${policyIdentification}`);
  }

  @Cacheable()
  public getAssociatedPolicies(): Observable<AssociatedPolicy[]> {
    return this.http.get<AssociatedPolicy[]>(`${enlineaBackendUrl}/api/seguros/Policies/AssociatedPolicies`);
  }

  @Cacheable()
  public getPolicyCoverages(filter: PolicyCoveragesFilter): Observable<CertificateCoverage[]> {
    const params = this.paramsService.mapRequestParams(filter);
    return this.http.get<CertificateCoverage[]>(`${enlineaBackendUrl}/api/seguros/Policies/PolicyCoverages`, { params });
  }
}
